<template>
	<main class="mypage icon_page">
		<UserMenu v-if="displayStore.isDesktop" />
		<article class="iconInfo">
			<h6>회원탈퇴</h6>
			<section class="icon_form">
				<div class="icon_wrapper">
					<img src="@/assets/img/mypage/questionMark.png" alt="회원 탈퇴 아이콘" loading="lazy" />
					<div class="icon_title">
						<p>정말 회원탈퇴 하시겠습니까?</p>
						<p>탈퇴시 회원님의 계정에 저장된 모든 정보가 <br />영구삭제되며 복구되지 않습니다.</p>
					</div>
				</div>
				<div class="c_fieldArea">
					<button class="c_button radius-x-small primary-fill save" @click="$router.go(-1)">취소</button>
				</div>
				<div class="icon">
					<button class="c_button leave" @click="onClickLeave">
						회원탈퇴<img src="@/assets/img/common/arrow_next.svg" alt="회원탈퇴하기 아이콘" loading="lazy" />
					</button>
				</div>
			</section>
		</article>
	</main>
</template>

<script setup lang="ts">
// api
// lib
import { useRouter } from 'vue-router';

import { useQuitMemberApi } from '@/api/mypage';
// component
import UserMenu from '@/components/mypage/UserMenu.vue';
// store
import { useAuthStore } from '@/stores/auth';
import { useDisplayStore } from '@/stores/display';
import { useTokenStore } from '@/stores/token';

// -----variable-----
const displayStore = useDisplayStore();
const router = useRouter();
const authStore = useAuthStore();
const tokenStore = useTokenStore();
// -----api-----
const { mutateAsync: quitMember } = useQuitMemberApi();
// -----function-----
const onClickLeave = async () => {
	const res = await quitMember();
	if (res.data.success) {
		authStore.resetAuth();
		tokenStore.resetToken();
		router.replace('/my/edit/account-delete-complete');
	}
};
</script>

<style lang="scss" scoped>
.leave {
	padding: 1.4rem 0rem 0rem 0rem;
	height: unset;
}
</style>
